import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';
import locale from 'antd/es/locale/ja_JP';
import 'moment/locale/vi';
import { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import tokens from '@/styles/tokens';
import { AuthProvider } from './Auth';
import ReactQueryProvider from './ReactQuery';
import { StateGlobalProvider } from './StateGlobal';

const AllProviders = ({ children }: { children: ReactNode }) => {
  return (
    <HelmetProvider>
      <StyleProvider layer>
        <ConfigProvider
          theme={{
            hashed: false,
            token: {
              colorBgContainer: tokens.colors.bgContainer,
              colorPrimary: tokens.colors.primary,
              padding: 12,
              paddingContentVertical: 8,
            },
            components: {
              Form: {
                itemMarginBottom: 16,
                verticalLabelPadding: '0 0 4px',
              },
              Table: {
                cellPaddingBlock: 8,
                cellPaddingInline: 12,
              },
              Menu: {
                itemHeight: 36,
                itemMarginInline: 6,
              },
            },
          }}
          locale={locale}
        >
          <ReactQueryProvider>
            <AuthProvider>
              <StateGlobalProvider>{children}</StateGlobalProvider>
            </AuthProvider>
          </ReactQueryProvider>
        </ConfigProvider>
      </StyleProvider>
    </HelmetProvider>
  );
};

export default AllProviders;
